import React from 'react';
import styled from '@emotion/styled';
import { AsyncDataPlaceholder } from '../../../../../../ui';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { useHasRequiredFields } from '../helpers/useHasRequiredFields';
import { usePaymentFormContext } from '../helpers/usePaymentFormContext';
import { theme } from '../../../../../shared/styles';
import { ButtonWithLoader } from '../../../../../../ui/components/Button/ButtonWithLoader';

interface IPaymentSubmitProps {
	shouldProceedWithoutPay?: boolean;
}

export const PaymentSubmit = ({
	shouldProceedWithoutPay,
}: IPaymentSubmitProps) => {
	const { t } = useTranslation();
	const hasPaymentRequiredFields = useHasRequiredFields();
	const hasRequiredFields =
		Boolean(shouldProceedWithoutPay) || hasPaymentRequiredFields;
	const {
		formState: { isSubmitting },
	} = usePaymentFormContext();

	const disabled = !hasRequiredFields || isSubmitting;

	return (
		<>
			{isSubmitting && <AsyncDataPlaceholder />}

			<StyledSubmitButton
				type="submit"
				disabled={disabled}
				isLoading={isSubmitting}
			>
				{shouldProceedWithoutPay
					? t('web_booking_details_summary_submit_proceed')
					: t('web_parking_payment_submit_button')}
			</StyledSubmitButton>
		</>
	);
};

const StyledSubmitButton = styled(ButtonWithLoader)`
	justify-content: center;
	font-family: inherit;
	padding: 14px 16px;
	border-radius: 4px;
	box-shadow: 0px -3px 0px 0px #005b99 inset;
	outline: none;

	&:focus-visible {
		outline: ${theme.button?.primary?.focus?.outline};
	}
`;
